import { z } from "zod";

// "Branded" Typen: technisch nur ein string, aber der Compiler verhindert, dass man
// versehentlich einen beliebigen string (oder eine UserId) als TenantId uebergibt.
// Das ist eine zusaetzliche Sicherheitsebene fuer die Mandantentrennung - genau an
// den Stellen, wo Verwechslungen gefaehrlich waeren (CLAUDE.md, Sicherheitsregel 1).
export type TenantId = string & { readonly __brand: "TenantId" };
export type UserId = string & { readonly __brand: "UserId" };

// UUID-Format (beliebige Version; IDs werden als UUIDv7 erzeugt - zeitlich sortierbar).
const UUID_RE = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;

// Zod-Schema: validiert das UUID-Format zur Laufzeit (an der API-Grenze).
export const uuidSchema = z.string().regex(UUID_RE, "Keine gueltige UUID");

// Wandeln eine (validierte) UUID in den gebrandeten Typ. Wirft bei ungueltigem Wert.
export function toTenantId(value: string): TenantId {
  return uuidSchema.parse(value) as TenantId;
}

export function toUserId(value: string): UserId {
  return uuidSchema.parse(value) as UserId;
}
